<template>
    <div>
            <TableList ref="tablePagin" :data.sync='this.data'
                @updateContentState="this.updateContent"
                :paginationClass="'col-sm-3'"
                :sortRule="this.sort_rule"
                :head_slot="true"
                :indexes="['name', 'keyt', 'curr', 'balance', 'alias']">
                <template v-slot:head>
                    <div class="d-flex align-items-center flex-wrap" :class="isMobile && 'mb16'">
                        <div class="col-12" role="group" aria-label="Basic outlined example" :class="{ 'flex-grow-1': isMobile }">
                            <CustomSelectButton
                                class="h40"
                                v-model:modelValue="this.stage"
                                :options="[
                                    { label: $t('views.Keyts.List.15'), value: 0 }, 
                                    { label: $t('views.Keyts.List.25'), value: 1 }, 
                                    { label: $t('views.Keyts.List.24'), value: 2 }
                                ]" 
                            />
                        </div>
                    </div>
                </template>
                <template v-slot:table>
                <div  v-if="this.content.length > 0" class="table-div border-b">
                    <div v-if="!isMobile" class="d-flex align-items-center px-4 pbp-20 ptp-20 border-b">
                        <div class="col-3 d-flex align-items-center pointer" :class="{ 'col-4': this.$store.state.resize.w <= 1024 }">
                            <Popper type="sort">
                                <div class="d-flex">
                                    <h4 class='neue-roman fsp14 primary-grey mbp-0 text-truncate' :class="{ 'text-black': this.sort_rule.ind === 'keyt' }">{{ $t('views.Home.8') }}</h4>
                                    <Icon :name="'chevron-up-down'" :color="this.sort_rule.ind === 'keyt' && iconColor" class="ml4 c18" />
                                </div>
                                <template #content>
                                    <div 
                                        @click="sort_rule = { type: '', to: false, ind: 'keyt' }" 
                                        class="text-nowrap sort-option mb4 d-flex align-items-center fsp14"
                                        :class="{ 'active': this.sort_rule.to === false && this.sort_rule.ind === 'keyt' }"
                                    >
                                        <Icon :name="'arrow-up'" class="c18 mr8" />
                                        {{ $t('views.Keyts.List.49') }}
                                    </div>
                                    <div
                                        @click="sort_rule = { type: '', to: true, ind: 'keyt' }" 
                                        class="text-nowrap sort-option d-flex align-items-center fsp14"
                                        :class="{ 'active': this.sort_rule.to === true && this.sort_rule.ind === 'keyt' }"
                                    >
                                        <Icon :name="'arrow-down'" class="c18 mr8" />
                                        {{ $t('views.Keyts.List.50') }}
                                    </div>
                                </template>
                            </Popper>
                        </div>
                        <div v-if="this.$store.state.resize.w > 1024" class="col-3 d-flex align-items-center pointer">
                            <Popper type="sort">
                                <div class="d-flex">
                                    <h4 class='neue-roman fsp14 primary-grey mbp-0' :class="{ 'text-black': this.sort_rule.ind === 'explorer_link' }">{{ $t('views.Keyts.List.42') }}</h4>
                                    <Icon :name="'chevron-up-down'" :color="this.sort_rule.ind === 'explorer_link' && iconColor" class="ml4 c18" />
                                </div>
                                <template #content>
                                    <div 
                                        @click="sort_rule = { type: '', to: false, ind: 'explorer_link' }" 
                                        class="text-nowrap sort-option mb4 d-flex align-items-center fsp14" 
                                        :class="{ 'active': this.sort_rule.to === false && this.sort_rule.ind === 'explorer_link' }"
                                    >
                                        <Icon :name="'arrow-up'" class="c18 mr8" />
                                        {{ $t('views.Keyts.List.49') }}
                                    </div>
                                    <div 
                                        @click="sort_rule = { type: '', to: true, ind: 'explorer_link' }" 
                                        class="text-nowrap sort-option d-flex align-items-center fsp14" 
                                        :class="{ 'active': this.sort_rule.to === true && this.sort_rule.ind === 'explorer_link' }"
                                    >
                                        <Icon :name="'arrow-down'" class="c18 mr8" />
                                        {{ $t('views.Keyts.List.50') }}
                                    </div>
                                </template>
                            </Popper>   
                        </div>
                        <div class="col-3 flex-shrink-1 d-flex align-items-center pointer" 
                            :class="{ 
                                'col-4': this.$store.state.resize.w <= 1024, 
                                'w246': this.$store.state.resize.w > 1400,
                                'w200': this.$store.state.resize.w <= 1400 && this.$store.state.resize.w > 1024
                            }"
                        >
                            <Popper type="sort">
                                <div class="d-flex">
                                    <h4 class='neue-roman fsp14 primary-grey mbp-0' :class="{ 'text-black': this.sort_rule.ind === 'balance' }">{{ $t('views.Keyts.List.43') }}</h4>
                                    <Icon :name="'chevron-up-down'" :color="this.sort_rule.ind === 'balance' && iconColor" class="ml4 c18" />
                                </div>
                                <template #content>
                                    <div 
                                        @click="sort_rule = { type: 'int', to: false, ind: 'balance' }" 
                                        class="text-nowrap sort-option mb4 d-flex align-items-center fsp14"
                                        :class="{ 'active': this.sort_rule.to === false && this.sort_rule.ind === 'balance' }"
                                    >
                                        <Icon :name="'arrow-up'" class="c18 mr8" />
                                        {{ $t('views.Keyts.List.49') }}
                                    </div>
                                    <div 
                                        @click="sort_rule = { type: 'int', to: true, ind: 'balance' }" 
                                        class="text-nowrap sort-option d-flex align-items-center fsp14"
                                        :class="{ 'active': this.sort_rule.to === true && this.sort_rule.ind === 'balance' }"
                                    >
                                        <Icon :name="'arrow-down'" class="c18 mr8" />
                                        {{ $t('views.Keyts.List.50') }}
                                    </div>
                                </template>
                            </Popper>
                        </div>
                        <div class="flex-grow-1 d-flex align-items-center pointer" 
                            :class="{ 
                                'col-3': this.$store.state.resize.w <= 1024,
                                'w246 flex-shrink-1': this.$store.state.resize.w > 1400, 
                                'w200': this.$store.state.resize.w <= 1400 && this.$store.state.resize.w > 1024
                            }"
                        >
                            <Popper type="sort">
                                <div class="d-flex">
                                    <h4 class='neue-roman fsp14 primary-grey mbp-0' :class="{ 'text-black': this.sort_rule.ind === 'usdRate' }">{{ $t('views.Keyts.List.44') }} {{ this.$store.state.config.KEYTS_RATE_CURR_TEXT }}</h4>
                                    <Icon :name="'chevron-up-down'" :color="this.sort_rule.ind === 'usdRate' && iconColor" class="ml4 c18" />
                                </div>
                                <template #content>
                                    <div 
                                        @click="sort_rule = { type: 'int', to: false, ind: 'usdRate' }"
                                        class="text-nowrap sort-option mb4 d-flex align-items-center fsp14"
                                        :class="{ 'active': this.sort_rule.to === false && this.sort_rule.ind === 'usdRate' }"
                                    >
                                        <Icon :name="'arrow-up'" class="c18 mr8" />
                                        {{ $t('views.Keyts.List.49') }}
                                    </div>
                                    <div 
                                        @click="sort_rule = { type: 'int', to: true, ind: 'usdRate' }"
                                        class="text-nowrap sort-option d-flex align-items-center fsp14"
                                        :class="{ 'active': this.sort_rule.to === true && this.sort_rule.ind === 'usdRate' }"
                                    >
                                        <Icon :name="'arrow-down'" class="c18 mr8" />
                                        {{ $t('views.Keyts.List.50') }}
                                    </div>
                                </template>
                            </Popper>
                        </div>
                        <div class="w136 d-flex align-items-center">
                            <h4 class='neue-roman fsp14 primary-grey mbp-0 text-truncate'>{{ $t('views.Keyts.List.45') }}</h4>
                        </div>
                    </div>
                    <div v-for="(row, index) in this.content" :key="row.keyt"
                        class="col-12 pb-2 pt-2 px-4 d-flex flex-column align-items-center border-b"
                        :class="{ 'p16': isMobile, 'px24 py12': !isMobile}"
                    >
                    <div class="col-12 d-flex flex-lg-row" :class="{ 'flex-column align-items-start': isMobile, 'align-items-center': !isMobile }">
                        <div class="col-3 d-flex flex-row align-items-center justify-content-between" :class="{ 'col-12 border-b pb16 mb16': isMobile }">
                            <div class="d-flex flex-row align-items-center mh-52 col-10" :class="{ 'col-12': isMobile }">
                                <div v-if="row.image" class="item-i round-border contain c40" :class="{'mrp-10': isMobile, 'mrp-20': !isMobile}" :style="`background-image: url('${row.image}');`"></div>
                                <div v-else class="k-symbol" :class="{'mrp-10': isMobile, 'mrp-20': !isMobile}">
                                    <Icon name="default-curr" size="c40" />
                                </div> 
                                <div class="d-flex flex-column" :class="{ 'flex-grow-1': isMobile }">
                                    <Popper :hover="!isMobile ? true : false" :startleft="true" type="info-table">
                                        <div class='href neue-roman d-flex align-items-center flex-row'>
                                            <span v-if='row.alias' :title='row.alias' class="text-black flex-grow-1 neue fw-medium">{{this.sbstring(row.alias)}}</span>
                                            <span v-else class="text-black neue flex-grow-1 fw-medium">{{this.sbstring(row.keyt)}}</span>
                                            <Icon :name="'copy'" is_сolored class="pointer cli_2 ml4 c16" @click.stop="copy(row.alias ? row.alias : row.keyt)" />
                                        </div>
                                        <span class='primary-grey fsp14 d-block lh20 text-truncate' :class="{'fsp14': isMobile}" :title='row.name'>{{ isMobile ? row.name : this.sizedName(row.name)}}</span>
                                        <template #content>
                                            <div class="px12" :class="{ 'w246 text-break': isMobile }">
                                                <p class="d-flex align-items-center text-white lh28 mb4 fsp14" :class="{ 'lh20': isMobile }">
                                                    <Icon name="wallet" class="c16 mr8" :active="false" />
                                                    {{row.alias ? row.alias : row.keyt }}
                                                </p>
                                                <p class="d-flex align-items-center text-white lh28 mb-0 fsp14" :class="{ 'lh20': isMobile }">
                                                    <Icon name="text" class="c16 mr8" :active="false" />
                                                    {{ row.name }}
                                                </p>
                                            </div>
                                        </template>
                                    </Popper>
                                </div>
                            </div>
                        </div>
                        <div v-if="this.$store.state.resize.w > 1024" class="text-truncate" :class="{ 'col-3': this.$store.state.resize.w > 1024 }">
                            <div v-if="row.explorer_link" class="d-flex align-items-center">
                                <a :href="row.explorer_link" target="_blank" class="col-8 text-nowrap overflow-hidden text-truncate main-color neue fw-medium text-decoration-underline">{{ row.explorer_link }}</a>
                                <Icon :name="'external-link'" class="item-i ml4 c18" />
                            </div>
                        </div>
                        <div 
                            class="d-flex flex-grow-1 flex-column justify-content-between" 
                            :class="{
                                'w246': this.$store.state.resize.w > 1400, 
                                'w200': this.$store.state.resize.w <= 1400 && this.$store.state.resize.w > 1024, 
                                'col-4': this.$store.state.resize.w <= 1024 && !isMobile, 
                                'col-12': isMobile
                            }"
                        >
                            <div class="text-truncate" :class="{'col-10': !isMobile}">
                                <span class='neue-roman mr8' v-html='this.sumMask(row.balance)'></span>
                                <span class='primary-grey neue'>{{row.curr}}</span>
                            </div>
                        </div>
                        <div class="d-flex flex-row flex-shrink-1 align-items-center" :class="{ 
                            'col-3': this.$store.state.resize.w <= 1024, 
                            'w246': this.$store.state.resize.w > 1400, 
                            'w200': this.$store.state.resize.w <= 1400 && this.$store.state.resize.w > 1024, 
                            'col-12 border-b pb16 mb16': isMobile
                        }">
                            <div v-if="row.rate !== ''" class="col-7 overflow-hidden text-nowrap" :class="{ 'mt16': isMobile }">
                                <span class='neue-roman fsp16 mr8' v-html='this.sumMask(convertByRate(row))'></span>
                                <span class='primary-grey neue'>{{this.$store.state.config.KEYTS_RATE_CURR_TEXT}}</span>
                            </div>      
                        </div>
                        <div class="d-flex flex-row align-items-center justify-content-end" :class="{ 'col-12': isMobile, 'w136': !isMobile }">
                            <div class="d-flex gap-2 flex-row flex-grow-1" :class="{ 'mt12': isMobile }">
                                <Button 
                                    @click="paySelect(row, 'deposit')" 
                                    class="action-btn"
                                    :class="{ 'flex-grow-1': isMobile }"
                                    type='btn-warning' 
                                >
                                    <Icon v-if="!isMobile" :name="'deposit'" :size="'c18'" />
                                    <span v-if="isMobile" class="mlp-8 neue fw-medium fsp14" :style="'white-space: nowrap;'">{{ this.$t('views.Home.27') }}</span>
                                </Button> 
                                <Button 
                                    @mouseover="iconHover = `withdraw-${index}`"
                                    @mouseleave="iconHover = false"  
                                    @click="paySelect(row, 'withdraw')" 
                                    class="action-btn" 
                                    :class="{ 'flex-grow-1': isMobile }"
                                    type="btn-outline-warning" 
                                >
                                    <Icon v-if="!isMobile" :name="'withdraw'" :size="'c18'" :active="iconHover === `withdraw-${index}`" />
                                    <span v-if="isMobile" class="mlp-8 fsp14 neue fw-medium" :style="'white-space: nowrap;'">{{ this.$t('views.Home.26') }}</span>
                                </Button> 
                                <Button
                                    @mouseover="iconHover = `ellipsis-${index}`"
                                    @mouseleave="iconHover = false"  
                                    @click="showDetails(row)"
                                    class="action-btn" 
                                    type='btn-outline-grey' 
                                >
                                    <Icon :name="'ellipsis'" :size="'c18'" :active="iconHover === `ellipsis-${index}`" />
                                </Button> 
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div v-else class='mt-2 grey text-center'>
                    <h5>{{ $t('views.Keyts.List.20') }}</h5>
                </div>
                </template>
                <template v-slot:buttons>
                    <!-- <div class="d-flex container-fluid flex-wrap g-3 pb-1 p-0 align-items-center justify-content-between">
                        <div class='col-12 col-sm-4 d-flex justify-content-center justify-content-sm-start'>
                            <Button :name="this.k_name ? $t('views.Keyts.List.10') : $t('views.Keyts.List.11')" v-on:click='this.$router.push("/keyts/new")' class='' type='btn-outline-warning'/>
                        </div>
                    </div> -->
                </template>
        </TableList>
    </div>
</template>

<script>
import { gsap } from "gsap";
import TableList from '@/components/service/pagination/TableList';
import Dropdown from "@/components/service/Dropdown";
import Icon from "@/components/icons/Icon.vue";
import Button from '@/components/service/Button';
import ShowInfoVA from '@/components/service/ShowInfoVA.vue';
import Tooltip from '@/components/service/Tooltip';
import CustomSelectButton from "../CustomSelectButton.vue";
import Popper from "@/components/service/Popper";


export default {
    components: {
        Button,
        Dropdown,
        Icon,
        ShowInfoVA,
        TableList,
        Tooltip,
        CustomSelectButton,
        Popper
    },
    props: {
        data: [Array],
        of_stage: {
            default: 0,
            type: [Number, Boolean]
        }
    },
    data() {
        return {
            content: {},
            filtered: [],
            vaData: false,
            aliases: false,
            checked: false,
            boxes: {},
            stage: 0,
            mainChecked: false,
            categorys: [],
            btns_text: {},
            sort_rule: {
                ind: 'date_create',
                to: true,
                type: 'date'
            },
            oprationsList: [
                {
                    name: this.$t('views.Keyts.List.28'),
                    handler: (row) => {
                        this.$store.commit('MODAL', {
                            action: true,
                            type: 'PaySelect',
                            content: {
                                action: 'payIn',
                                keyt: row
                            }
                        })
                    },
                    icon: 'deposit'
                },
                {
                    name: this.$t('views.Keyts.List.29'),
                    handler: (row) => {
                        this.$store.commit('MODAL', {
                            action: true,
                            type: 'PaySelect',
                            content: {
                                action: 'payOut',
                                keyt: row
                            }
                        })
                        // this.$router.push({name: "Pay"});
                    },
                    icon: 'withdraw'
                },
                {
                    name: this.$t('views.Keyts.List.30'),
                    handler: (row) => {
                        this.$store.commit('MODAL', {
                            action: true,
                            type: 'PaySelect',
                            content: {
                                action: 'transfer',
                                keyt: row
                            }
                        })
                        // this.$router.push({name: "p2p_offers"});
                    },
                    icon: 'horizontal_arr'
                }
            ],
            settingsList: [
                {
                    name: this.$t('views.Keyts.List.31'),
                    handler: () => {
                        console.log('Скрыть');
                    },
                    disabled: true,
                    icon: 'eye-off'
                },
                {
                    name: this.$t('views.Keyts.List.32'),
                    handler: (row) => {
                        this.changeKeyt(row.keyt, row.name);
                    },
                    icon: 'edit_k'
                },
                {
                    name: this.$t('views.Keyts.List.33'),
                    handler: (row) => {
                        this.deleteKeyt(row.keyt, row.balance, row.alias)
                    },
                    icon: 'trash'
                }
            ],
            iconHover: false
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
        iconColor() {
            let obj = {}
            if(this.sort_rule.to) {
                obj[0] = '#000000'
            } else {
                obj[1] = '#000000' 
            }
            return obj
        }
    },
    watch: {
      stage() {
        this.$emit('updateStage', this.stage);
      }  
    },
    created() {
        this.getCategory();
    },
    methods: {
        copy(text) {
            this.$lib.copyTextS(text, this.$store)
        },
        paySelect(row, modalName) {
            if(modalName === 'deposit') {
                this.$store.commit('MODAL', {
                    action: true,
                    type: 'PaySelect',
                    content: {
                        title:  this.$store.state.resize.w < 768 ? this.$t('views.Keyts.List.28') : this.$t('views.Keyts.List.46'),
                        action: 'payIn',
                        keyt: { curr: row },
                        width: 608
                    }
                })
            } else if(modalName === 'withdraw') {
                this.$store.commit('MODAL', {
                    action: true,
                    type: 'PaySelect',
                    content: {
                        title: this.$store.state.resize.w < 768 ? this.$t('views.Keyts.List.29') : this.$t('views.Keyts.List.47'),
                        action: 'payOut',
                        keyt: { curr: row },
                        width: 608,
                    }
                })
            }
        },
        async showDetails(row) {
            let body
            if (row.custom === '1') {
                await this.getVAParams(row.curr_code)
                body = { ...this.vaData, curr: {  ...this.vaData.curr, ...row} }
            } else {
                body = { curr: { ...row } }
            }
            this.$store.commit('MODAL', {
                    action: true,
                    type: 'AssetDetails',
                    content: {
                        title: this.$t('views.Keyts.List.48'),
                        body,
                        width: 608,
                    },
                }
            );
        },
        sbstring(str) {
            if (this.$store.state.resize.w < 1024 && this.$store.state.resize.w > 768 && str.length > 7) {
                return this.$lib.getTokenString(str, 4);
            } else if(this.$store.state.resize.w <= 768) {
                return this.$lib.getTokenString(str, 10);
            } else if (this.$store.state.resize.w < 1200 && str.length > 12) {
                return this.$lib.getTokenString(str, 4);
            } else if (str.length > 30) {
                return this.$lib.getTokenString(str, 8);
            } 
            return this.$lib.getTokenString(str, 8);
        },
        convertByRate(arg) {
            return this.$lib.precRound(this, this.$lib.ev(this, `${arg.balance} * ${arg.rate}`), '2'); 
        },
        event_enter(el) {
            gsap.fromTo(el, { opacity: 0, width: 0 }, { opacity: 1, width: "auto", duration: 0.4 });
        },
        event_leave(el, done) {
            gsap.fromTo(el, { opacity: 1 }, { opacity: 0.1, width: 0, duration: 0.4, onComplete: done });
        },
        sizedName(str) {
            if (!str) {
                return "";
            } else if (this.$store.state.resize.w < 720 && str.length > 20) {
                return str.substring(0, 20) + "...";
            } else if (this.$store.state.resize.w < 1200 && str.length > 20) {
                return this.$lib.getTokenString(str, 8);
            } else if (str.length > 34) {
                return str.substring(0, 35) + "...";
            }
            return str;
        },
        sumMask(sum, isSameSize) {
            if (!sum) {
                return;
            }
            let classList = `${this.isMobile ? 'fsp16' : ''} text-black neue fw-medium`
            if(isSameSize) {
                classList = 'fsp12'
            }
            let arr = sum.split('.');
            if (arr[1]) {
                return `<span  class='${classList}'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span><span class='fsp12 primary-grey neue'>.${arr[1]}</span>`
            } else {
                return `<span  class='${classList}'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span>`
            }
        },
        smallSummMask(sum) {
            let arr = sum.split('.');
            if (arr[1]) {
                return `${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}.${arr[1]}`;
            } else {
                return `${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}`;
            }
        },
        bigBalance(sum) {
            let arr = sum.split('.');
            if (arr[0].length > 9) {
                let humVal = this.$lib.bignumberToHumanValue(arr[0]);
                return `<span  class='${this.isMobile ? 'fsp16' : ''}'>${humVal[0]} ${humVal[1]}</span>`
            } else {
                return this.sumMask(sum);
            }
        },
        getCategory() {
            this.axios.post('GetKeywords', {group: '115'}).then(res => {this.categorys = res.data.body});
        },
        async getVAParams(vaCode) {
            await this.axios.post('GetCustomCurrParams', {data: {code: vaCode}}).then(res => {
                if (res.data.body.result === '0') {

                    const linksDataArray = [
                        {code: '0', icon: 'va-host', text: this.$t('views.ShowInfoVA.21')},
                        {code: '1', icon: 'va-white-book', text: this.$t('views.ShowInfoVA.22')},
                        {code: '2', icon: 'va-mail', text: this.$t('views.ShowInfoVA.23')},
                        {code: '3', icon: 'va-telegram', text: 'Telegram'},
                        {code: '4', icon: 'va-twitter', text: 'Twitter'},
                        {code: '5', icon: 'va-facebook', text: 'Facebook'},
                        {code: '6', icon: 'whatsapp', text: 'WhatsApp'},
                        {code: '7', icon: 'linkedin', text: 'LinkedIn'},
                    ];

                    const vaDataCurr = res.data.body.advanced;

                    const category = this.categorys.find(item => item.code == vaDataCurr.category);
                    vaDataCurr.category = category.value;

                    const name = vaDataCurr.name_en ? vaDataCurr.name_en : vaDataCurr.name_ru;
                    vaDataCurr.name = name;
                    let tmp = {}
                    tmp.curr = vaDataCurr;
                    const links = res.data.body.tables[1].colvalues;
                    const linksResult = linksDataArray.filter((link) => links.some((item) => item.code == link.code));

                    linksResult.forEach((link) => {
                        const linkItem = links.find(item => item.code == link.code);
                        link.value = linkItem.value;
                    });
                    tmp.links = linksResult;
                    tmp.code = vaCode;

                    this.vaData = tmp;

                }
            })
        },
        updateContent(arg) {
            if (typeof arg == 'undefined') {
                arg = {}
            } else {
                this.aliases = false;
                arg.forEach(e => {
                    if (e.alias != '') {
                        this.aliases = true;
                    }
                });
            }
            this.content = arg;
            console.log('updateContent List page', this.content);
        },
        alltoDel(e) {
            if (e.checked) {
                this.content.forEach(e => {
                    if (e.balance == '0.00') {
                        this.boxes[e.keyt] = e.keyt
                    }
                })
                this.checked = true
            } else {
                this.checked = false
                this.boxes = {};
            }
        },
        toDel(e) {
            if (e.checked) {
                // this.boxes.push(e.value);
                this.boxes[e.value] = e.value
            } else {
                // this.boxes.splice(this.boxes.indexOf(e.value), 1);
                delete this.boxes[e.value]
            }
        },
        changeKeyt(keyt, name) {
            this.$store.commit('MODAL', {
                action: true,
                type: 'k_rename',
                content: {
                    text: this.$t('views.Keyts.List.16'),
                    keyt: keyt,
                    name: name,
                },
            });
        },
        delAll() {
            let data = [];
            for (let key in this.boxes) {
                data.push({'keyt': this.boxes[key]})
            }
            this.boxes = {};
            this.$store.commit('MODAL', {
                                        action: true,
                                        type: 'confirm',
                                        content: {
                                            text: this.$t('views.Keyts.List.17'),
                                            callback: () => {
                                                this.axios.post('DeleteKeyts', {data: data}).then(res => {
    
                                                })
                                            }
                                        },
                                    }
                                );
        },
    },
    
}
</script>

<style lang="scss" scoped>
.mh-52 {
    min-height: 52px;
}
.w136 {
    width: 136px;
}
.w246 {
    width: 246px;
}
.w200 {
    width: 200px;
}
.action-btn {
    width: 40px;
    height: 40px;
}
.custom-d-width {
    
    
    @media (min-width: 767px) {
    }
    @media (max-width: 1040px) {
        max-width: 150px;
        // width: 100% !important;
        // .custom_div {
        //     width: 49% !important;
        // }
    } 
    @media (max-width: 677px) {
        max-width: 100%;
    }
}
.btn-d-width {
    @media (min-width: 500px) { 
        min-width: 130px;
    }
}
</style>